'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIButton from 'UIComponents/button/UIButton';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import Small from 'UIComponents/elements/Small';
import PropTypes from 'prop-types';
import { getWidgets } from 'reporting-action-components/data/schemas/dashboardSchema';
import { isUnsupportedDataExportType as getUnsupportedDataExportType } from 'reporting-action-components/reportingActions/shared/emailLogic';
import { getId as getReportId } from 'reporting-action-components/data/schemas/reportSchema';
import { Set as ImmutableSet } from 'immutable';
import { sortByCoords } from '../../../lib/LayoutHelpers';
import SelectedWidgetCheckbox from './SelectedWidgetCheckbox';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IncludeReportsSelection = ({
  exportType,
  selectedReports,
  setSelectedReports,
  setShowReportsSelection,
  showReportsSelection,
  dashboard
}) => {
  const widgets = sortByCoords(getWidgets(dashboard));
  const isUnsupportedDataExportType = getUnsupportedDataExportType(exportType);
  const handleReportsSelectionChange = selectedReport => {
    setSelectedReports(prevSelectedReports => prevSelectedReports.has(selectedReport) ? prevSelectedReports.delete(selectedReport) : prevSelectedReports.add(selectedReport));
  };
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email.dashboard.prompt.includeReportsLabel"
    }),
    children: /*#__PURE__*/_jsxs(UIToggleGroup, {
      name: "includeReportsToggle",
      children: [/*#__PURE__*/_jsx(UIRadioInput, {
        defaultChecked: true,
        value: "all",
        onChange: () => {
          setSelectedReports(ImmutableSet()); // Reset selected reports whenever the user chooses to email all reports.
          setShowReportsSelection(false);
        },
        description: isUnsupportedDataExportType && /*#__PURE__*/_jsx(UIHelpIcon, {
          title: /*#__PURE__*/_jsxs(Small, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "email.dashboard.unsupportedDataExportForAllReportsTooltip"
            }), ' ', /*#__PURE__*/_jsx(UIButton, {
              external: true,
              use: "link",
              href: "https://knowledge.hubspot.com/dashboard/email-or-export-reports-and-dashboards#export-a-report",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "email.dashboard.unSupportedDataExportLearnMoreLink"
              })
            })]
          })
        }),
        descriptionLayout: "horizontal",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email.dashboard.prompt.includeAll"
        })
      }), /*#__PURE__*/_jsx(UIRadioInput, {
        value: "selected",
        onChange: () => {
          setShowReportsSelection(true);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email.dashboard.prompt.includeSelected"
        })
      }), showReportsSelection && /*#__PURE__*/_jsx(View, {
        paddingInlineStart: "700",
        as: "div",
        children: widgets.map(widget => {
          const report = widget.get('report');
          return /*#__PURE__*/_jsx(SelectedWidgetCheckbox, {
            report: report,
            exportType: exportType,
            handleReportsSelectionChange: handleReportsSelectionChange,
            selectedReports: selectedReports
          }, getReportId(report));
        })
      })]
    })
  });
};
IncludeReportsSelection.propTypes = {
  exportType: PropTypes.string.isRequired,
  selectedReports: PropTypes.object.isRequired,
  setSelectedReports: PropTypes.func.isRequired,
  dashboard: PropTypes.object.isRequired,
  setShowReportsSelection: PropTypes.func.isRequired,
  showReportsSelection: PropTypes.bool.isRequired
};
export default IncludeReportsSelection;